"use strict";

exports.__esModule = true;
exports.default = void 0;

function createContext(selector, type, options) {
  if (type === void 0) {
    type = '2d';
  }

  if (options === void 0) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    var canvasNode = document.getElementById(selector);
    if (!canvasNode) reject('The canvas node may not exist.');
    var context = canvasNode.getContext(type, options); // For fallback

    context.draw = function () {};

    resolve(context);
  });
}

var _default = createContext;
exports.default = _default;